// React
import { useTranslation } from "react-i18next";

// MUI
import { Box, Stack, Typography } from "@mui/material";

// QR Components
import { QRCloseButton } from "../QRCloseButton";
import { useQR } from "../QRContext";

// Styles
import styles from "../styles";

// Luxon
import { DateTime } from "luxon";

const convertMonthToLetters = (date) =>
  DateTime.fromFormat(date, "yyyy-MM-dd").toFormat(`yyyy-LLL-dd`).toUpperCase();

const HealthCardEntry = ({ field, fieldName }) => {
  return (
    <Box sx={{ mb: 0.5 }}>
      <Typography sx={styles.healthCardField}>{field}</Typography>
      <Typography sx={styles.healthCardFieldName}>{fieldName}</Typography>
    </Box>
  );
};

/**
 * @brief Summary of the user's QR Code that they scanned, laid out like a newer MB Health Card
 *
 * @param closeFunction call this upon successful QR code read to close the dialog properly
 * @param altCloseLabel (optional) Label for the action to perform on close after successful scan.
 */
export const QRCodeSummary = ({ closeFunction, altCloseLabel }) => {
  const { qrJSON } = useQR();
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" spacing={1}>
      <Box boxShadow={10} sx={styles.summaryBox}>
        <Box
          sx={styles.healthCardImage}
          component="img"
          src="/healthcard cover.jpg"
          alt="health card cover"
        />
        <Box sx={styles.healthCardContent}>
          <Box sx={{ mb: 1.25 }}>
            <Typography sx={styles.healthCardField}>
              {qrJSON.firstName}
            </Typography>
            <Typography sx={styles.healthCardField}>
              {qrJSON.lastName}
            </Typography>
          </Box>

          <HealthCardEntry
            field={qrJSON.regNum}
            fieldName={t("qrcode.regNum")}
          />

          <HealthCardEntry field={qrJSON.phin} fieldName={t("qrcode.phin")} />

          <HealthCardEntry
            field={convertMonthToLetters(qrJSON.dob)}
            fieldName={t("qrcode.dob")}
          />

          <HealthCardEntry field={qrJSON.lang} fieldName={t("qrcode.lang")} />
        </Box>
      </Box>
      <Typography sx={styles.mainText}>{t("qrcode.scanComplete")}</Typography>
      <QRCloseButton onClose={closeFunction} altCloseLabel={altCloseLabel} />
    </Stack>
  );
};
